export default __webpack_public_path__ + "static/media/alert_1.c5f4488f.png";